import { Form } from "react-router-dom";
import { FormItemType } from "../../UI/view/component-map";
import { FormView } from "../../UI/view/form-view";
import { createView, initView } from "../../UI/view/view";
import { bulkInsertPackagedProduct, getCachedSerialNumbers, getCachedProductTypeIds } from "../../../services/requests/dewarrequests";

export const bulkInsertDataSource = {
  name: 'packagedProductDS',
  pk: 'id',
  createRequest: bulkInsertPackagedProduct
};

/*
whats on the page
Upload Button
a edit table
Confirm Button
*/

export const bulkInsertForm = {
  editMode: false,
  /*   editMode: true, */
  // Define the form fields and structure for bulk insert
  items: [
    {
      type: FormItemType.tab,
      items: [
        {
          label: 'Bulk Insert',
          items: [
            {
              type: FormItemType.fieldset,
              items: [
                {
                  type: FormItemType.fileUpload,
                  /*      fitToContent: true, */
                  setValueFieldName: 'packagedProducts',
                  columnAccessors: ['serialNumber', 'packagedProductType', 'tareWeight', 'currentVolume', 'manufacturedDate'],
                  hiddenColumnDefaults: { assetType: 'PackagedProduct' },
                } as any,

                {
                  type: FormItemType.boundingBox,
                  height: 400,
                  items: [
                    {
                      type: FormItemType.row,
                      items: [
                        {
                          type: FormItemType.editTable,
                          hideAddButton: true,
                          showEmptyTable: true,
                          name: 'packagedProducts',
                          columns: [
                            {
                              accessor: 'serialNumber',
                              Header: 'Serial Number',
                              formItemProps: {
                                name: 'serialNumber',
                                required: true,
                                defaultValue: null,
                                disabled: () => true,
                                validation: {
                                  checkUniqueSerialNumber: {
                                    async: true,
                                    debounce: 0,
                                    message: 'Serial number already exists',
                                    handler: async (val) => {
                                      const serialNumbers = await getCachedSerialNumbers();
                                      return !serialNumbers.includes(val);
                                    }
                                  }
                                }
                              }
                            },
                            {
                              accessor: 'packagedProductType',
                              Header: 'Product Type',
                              formItemProps: {
                                name: 'packagedProductType',
                                required: true,
                                defaultValue: null,
                                disabled: () => true,
                                validation: {
                                  validProductType: {
                                    async: true,
                                    debounce: 0,
                                    message: 'Invalid product type',
                                    handler: async (val) => {
                                      const productTypeIds = await getCachedProductTypeIds();
                                      return productTypeIds.find(x => x == val) !== undefined;
                                    }
                                  }
                                }
                              }
                            },
                            {
                              accessor: 'tareWeight',
                              Header: 'Tare Weight',
                              formItemProps: {
                                name: 'tareWeight',
                                required: true,
                                defaultValue: null,
                                number: true,
                                disabled: () => true
                              }
                            },
                            {
                              accessor: 'currentVolume',
                              Header: 'Current Volume',
                              formItemProps: {
                                name: 'currentVolume',
                                required: true,
                                defaultValue: null,
                                number: true,
                                disabled: () => true
                              }
                            },
                            {
                              accessor: 'manufacturedDate',
                              Header: 'Manufactured Date',
                              formItemProps: {
                                name: 'manufacturedDate',
                                type: FormItemType.date,
                                required: true,
                                defaultValue: null,
                                disabled: () => true
                              }
                            },
                            {
                              accessor: 'assetType',
                              Header: 'assetType',
                              hidden: true,
                              formItemProps: {
                                defaultValue: 'PackagedProduct',
                                name: 'assetType',
                                required: true,
                              }
                            }
                          ]
                        },
                      ]
                    },

                  ]
                },
              ]
            }

          ],
          footerItems: [
/*             {
              type: FormItemType.button,
              label: 'Cancel',
              fitToContent: true,
              handler: async ({ watch, confirm, loadEntity, modalContext }) => {
                modalContext.setModalClose()
              }
            }, */
            {
              type: FormItemType.submitButton,
              label: 'Verify and Insert',
              fitToContent: true,
              onAfterSubmit: ({ redirect, confirm, modalContext }) => {
                getCachedSerialNumbers.clear();
        /*         modalContext.setModalClose(); */
              }
            }
          ]
        }

        /*     {
              type: FormItemType.button,
              label: 'Upload',
              fitToContent: true,
            } */
      ]
    },


    /*     {
          type: FormItemType.row,
          items: [
            {
              type: FormItemType.button,
              label: 'Upload',
              fitToContent: true,
            } 
          ]
        } */
  ]
} as FormView;


export const BulkInsertForm = initView({ form: bulkInsertForm, dataSource: bulkInsertDataSource });